import React from 'react';
import PropTypes from 'prop-types';
import Slides from '@ifeng/ui_pc_slides';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { handleAd } from '@ifeng/ui_pc_ad';
import Chip from 'Chip';

let flag = 0;

class RecommendSlide extends React.PureComponent {
    state = {
        recommendData: this.props.recommendData,
    };

    ref = React.createRef();

    async componentDidMount() {
        const { infoAd5 } = this.props.adData;

        try {
            const callbackFn = await handleAd(infoAd5);

            callbackFn(this.ref.current, infoAd5.data);
        } catch (e) {
            console.error(e);
        }
    }

    sliderTmpl = list => {
        flag++;

        return (
            <div className={styles.slideItem}>
                {list && list.map
                    ? list.map((item, index) => (
                          <a
                              href={item.url}
                              key={index}
                              className={styles.link}
                              imgindex={index}
                              ref={(flag === 2 || flag === 7) && index === 4 ? this.ref : ''}>
                              <img src={item.thumbnail} width="180px" height="122px" />
                              <div className={styles.title}>{item.title}</div>
                          </a>
                      ))
                    : ''}
            </div>
        );
    };

    sliderTmplFo = list => {
        return (
            <div className={styles.slideItem}>
                {list && list.map
                    ? list.map((item, index) => (
                          <a href={item.url} key={index} className={styles.link} imgindex={index}>
                              <img src={item.thumbnail} width="180px" height="122px" />
                              <div className={styles.title}>{item.title}</div>
                          </a>
                      ))
                    : ''}
            </div>
        );
    };

    render() {
        let { recommendData } = this.state;
        const { isFo } = this.props;

        console.log(isFo);

        if (!(recommendData instanceof Array)) {
            recommendData = [];
        }

        // channelTitle根据不同频道进行，匹配数据
        const newList = [recommendData.slice(0, 5), recommendData.slice(5, 10), recommendData.slice(10)];
        const config = {
            arrows: false,
            dotsAction: 'hover',
            autoplay: true,
            autoplayInterval: 6000,
            speed: 1000,
            sliderTmpl: !isFo ? this.sliderTmpl : this.sliderTmplFo,
            dotStyle: styles.dot,
            dotCurrentStyle: styles.current,
        };

        return (
            <Chip
                id={!isFo ? '20039' : '60057'}
                type="recommend"
                title="上推广"
                groupName="正文"
                content={recommendData}>
                <div className={styles.container}>
                    <div className={styles.box}>
                        <Slides content={newList} config={config} />
                    </div>
                </div>
            </Chip>
        );
    }
}

/**
 * 定义组件属性类型
 * */
RecommendSlide.propTypes = { recommendData: PropTypes.array, adData: PropTypes.object, isFo: PropTypes.bool };

/**
 * 定义组件默认属性
 * */
RecommendSlide.defaultProps = {};

export { RecommendSlide };
export default errorBoundary(RecommendSlide);
